import { Button } from '@clockout-dev/design-elements';
import { RESTRICTED_CRITERIA_DEFS, SEGMENTATION_MODE, MODE_DESCRIPTIONS } from '../../../configuration.constants';
import RestrictedCriterionCard from './RestrictedCriterionCard';
import NoticePanel from './NoticePanel';
import styles from '../styles/userEligibilityForm.module.scss';

function RestrictedPanel({ values = {}, handlers = {}, readOnly = false, savedMode }) {
    const criteria = values.restrictedCriteria || {};
    const isRestricted = savedMode === SEGMENTATION_MODE.RESTRICTED;
    const buttonText = isRestricted ? 'Update restricted criteria' : 'Activate restricted mode';

    return (
        <div className={styles.restrictedPanel}>
            <NoticePanel description={MODE_DESCRIPTIONS[SEGMENTATION_MODE.RESTRICTED]} />
            <div className={styles.criteriaList}>
                {RESTRICTED_CRITERIA_DEFS.map((def) => (
                    <RestrictedCriterionCard
                        key={def.key}
                        def={def}
                        criterion={criteria[def.key] || {}}
                        readOnly={readOnly}
                        onToggle={() => {
                            if (handlers.toggleRestrictedCriterion) {
                                handlers.toggleRestrictedCriterion(def.key);
                            }
                        }}
                        onChangeOperator={(v) => {
                            console.log('[RestrictedPanel] operator change:', def.key, v);
                            if (handlers.setRestrictedCriterionOperator) {
                                handlers.setRestrictedCriterionOperator(def.key, v);
                            } else {
                                console.error('[RestrictedPanel] setRestrictedCriterionOperator handler not found');
                            }
                        }}
                        onChangeValue={(v) => {
                            if (handlers.setRestrictedCriterionValue) {
                                handlers.setRestrictedCriterionValue(def.key, v);
                            }
                        }}
                        onChangeWindowDays={(v) => {
                            if (handlers.setRestrictedCriterionWindow) {
                                handlers.setRestrictedCriterionWindow(def.key, v);
                            }
                        }}
                    />
                ))}
            </div>
            <Button
                type="submit"
                className={styles.buttonRestricted}
            >
                {buttonText}
            </Button>
        </div>
    );
}

export default RestrictedPanel;
